
import { Vue, Component, Prop } from "vue-property-decorator";
import SectionHeader from "./components/SectionHeader.vue";
import InfoField from "./components/InfoField.vue";
import InfoSection from "./components/InfoSection.vue";

@Component({
  components: {
    SectionHeader,
    InfoField,
    InfoSection,
  },
})
export default class ClientServices extends Vue {
  @Prop({ type: Object, required: true }) readonly data!: any;
   @Prop({ type: Object, required: true }) readonly proejctData!: any;
  @Prop({ type: Object, required: true }) readonly currentUser!: object;

  // These would typically come from the data, but for demonstration purposes
  // I'm hardcoding them based on the Figma design. In production, you'd want to
  // map this from data.client_services or similar.
  get allServices(): string[] {
    if (this.proejctData.support_type && Array.isArray(this.proejctData.support_type)) {
      return this.proejctData.support_type;
    }

    return [];
  }

  get firstColumnServices(): string[] {
    const mid = Math.ceil(this.allServices.length / 2);
    return this.allServices.slice(0, mid);
  }

  get secondColumnServices(): string[] {
    const mid = Math.ceil(this.allServices.length / 2);
    return this.allServices.slice(mid);
  }
}
